import React from "react";

const disabledInputClass =
  "w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg text-gray-900 bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:text-white cursor-not-allowed select-none";

const enabledInputClass =
  "w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg text-gray-900 bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all";

const labelClass =
  "block text-sm font-medium text-gray-700 mb-1 dark:text-white/90";

const iconClass =
  "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4";

export interface LinknetInfoProps {
  label: string;
  name: string;
  value: string;
  icon: React.ReactNode;
  disabled?: boolean;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function LinknetInfo({
  label,
  name,
  value,
  icon,
  disabled = false,
  type = "text",
  onChange,
}: LinknetInfoProps) {
  return (
    <div>
      <label className={labelClass}>{label}</label>
      <div className="relative">
        <span className={iconClass}>{icon}</span>
        <input
          type={type}
          name={name}
          value={value}
          disabled={disabled}
          onChange={disabled ? undefined : onChange}
          className={disabled ? disabledInputClass : enabledInputClass}
        />
      </div>
    </div>
  );
}
